export enum FolderPurpose {
  PublicInformation = 0,
  TeamLeaderInformation = 1,
  VipInformation = 2,
  UploadTeamLeader = 3,
  CoordinationTeamExchange = 4,
}
